import { Injectable } from '@angular/core';
import { Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { FeatureService } from '@core/services/feature/feature.service';

@Injectable()
export class ActionItemsGuard implements CanActivate {
  private isActionItemsSupported: boolean;

  constructor(private featureService: FeatureService, private router: Router) {
    this.featureService.isActionItemsSupported.subscribe(value => (this.isActionItemsSupported = value));
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.isActionItemsSupported) {
      return true;
    }

    this.router.navigate(['/projects']);
    return false;
  }
}
